/**
 * Strings for the Toolbox (dev/staging tools) feature.
 */
export const toolbox = {
  pageTitle: "Toolbox",
  description:
    "Development and debugging tools. These are only available in staging and local development environments.",

  tools: {
    colors: {
      title: "Color Editor",
      description: "Experiment with color theme variables in real-time.",
    },
    extensionTest: {
      title: "Extension Test",
      description:
        "Test harness for Chrome extension development. View and label test documents.",
    },
    debugReplay: {
      title: "Debug Replay",
      description:
        "View edit replay for any portal document owned by an internal user.",
    },
  },
} as const;

export type ToolboxStrings = typeof toolbox;
